import {onDomReady} from "../lib/on_dom_ready";

onDomReady(() => {
  const checkboxes = document.querySelectorAll('.end-user-agreement input[type="checkbox"]');
  const acceptButton = document.querySelector("#accept");

  if (!acceptButton) {
    return;
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      const allChecked = Array.from(checkboxes).every((item) => {
        return item.checked;
      });

      acceptButton.disabled = !allChecked;

      if (allChecked) {
        acceptButton.removeAttribute("aria-disabled");
      } else {
        acceptButton.setAttribute("aria-disabled", "true");
      }
    });
  });
});
